
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class TAudio extends Base {
  audioElement: HTMLAudioElement | null = null;

  errorTimeout = -1;

  mounted() {
    if (this.$refs.audio)
      this.audioElement = this.$refs.audio as HTMLAudioElement;
  }

  get src() {
    return this.config.audioSrc?.toString() || this.config.src?.toString();
  }

  get loop() {
    return this.config.loop === true;
  }

  ended() {
    this.emitDone();
  }

  error() {
    clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => {
      if (this.audioElement) {
        this.audioElement.load();
        this.audioElement.currentTime = 0;
        this.audioElement.play();
      }
    }, 3000);
  }
}
